import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import AuthService from '../../../business-api/AuthService'

//import ClienteService from '../../../business-api/ClienteService'

import {
    GridContainerReport,
    GridItem1,
    GridItem2,
    //GridItem3,
    GridItem4,
    GridItem6,
    GridItem8,
    //GridItem9,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

//import {
//    dataAtual,
//    formataData,
//} from '../../../business-components/Date/Date'

import {
    ImgLogoReport,
} from '../../../business-components/Img/Img'

import {
    SvgImageDesenvolvidoPorFintracks,
} from '../../../business-components/SvgImage/SvgImage'



const useStyles = makeStyles(theme => ({
    imgCapaBackground: ({ variaveisGlobais, values }) => ({
        //height: '1200px',
        //width: '793.70px',
        position: 'relative',
        top: '0px',
        backgroundImage:  "url('" +
            (AuthService.obterBackgroundPaginaRelatorio(variaveisGlobais)
                ?
                    AuthService.obterBackgroundPaginaRelatorio(variaveisGlobais)
                :
                            ''
            ) + "')",
        backgroundRepeat: 'no-repeat',
    }),
}))



const EstudoReportPage = ({ variaveisGlobais, values, vars, cabecalho, paginaInteira, conteudo, pagina, espacoModoApresentacao }) => {

    const classes = useStyles({variaveisGlobais, values})

    const corCabecalho =
        values.modoApresentacao && (COLOR().cabecalhoRelatorio === '#FFFFFF' || COLOR().cabecalhoRelatorio === '#ffffff')
            ?
                ''
            :
                'text-cabecalhoRelatorio '

    const Cabecalho = () => {

        return (
            <GridContainerReport
                //className='bg-estudoReportPageCabecalho'
                //style={{
                //    height: '2.5cm',
                //}}
                className={values.modoApresentacao ? 'mt--6' : values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? '' :''/*'mt--5'*/}
            >
                {/*
                <GridItem9
                    align="left"
                >
                    {cabecalho.length > 75
                        ?
                            <div
                                className='ml-5 mt-3 text-18 font-semibold'
                                dangerouslySetInnerHTML={{ __html: cabecalho }}
                            />
                        :
                            cabecalho.length > 40
                                ?
                                    <div
                                        className='ml-5 mt-6 text-20 font-semibold'
                                        dangerouslySetInnerHTML={{ __html: cabecalho }}
                                    />
                                :
                                    <div
                                        className='ml-5 mt-4 text-30 font-semibold'
                                    >
                                        {cabecalho}
                                    </div>
                    }
                </GridItem9>

                <GridItem1/>

                <GridItem2
                    align="center"
                    className="mt-5"
                >
                    <h1>
                        {pagina}
                    </h1>
                </GridItem2>
                */}
                <GridItem8
                    align="left"
                >
                    <GridContainerReport>
                        <GridItem11
                            className={
                                vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioMargemEsquerdaCabecalho &&
                                !values.modoApresentacao
                                    ?
                                        'ml-' + vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioMargemEsquerdaCabecalho
                                    :
                                        ''
                            }
                        >
                            {cabecalho
                                ?
                                    cabecalho.length > 60 && !values.modoApresentacao
                                        ?
                                            <div
                                                className={
                                                    'ml-5 text-15 font-medium ' + corCabecalho + 
                                                        (values.modoApresentacao ? 'mt-10' : 'mt-9'/*'mt-10'*/)
                                                }// mudança da fonte: text-16
                                                dangerouslySetInnerHTML={{ __html: cabecalho }}
                                            />
                                        :
                                            cabecalho.length > 40 && !values.modoApresentacao
                                                ?
                                                    <div
                                                        className={
                                                            'ml-5 text-15 font-medium ' + corCabecalho +
                                                                (values.modoApresentacao ? 'mt-10' : 'mt-14'/*'mt-15'*/)
                                                        } // mudança da fonte: text-16
                                                        dangerouslySetInnerHTML={{ __html: cabecalho }}
                                                    />
                                                :
                                                    cabecalho.length > 30 && !values.modoApresentacao // mudança da fonte
                                                        ?
                                                            <div
                                                                className={
                                                                    'ml-5 text-20 font-medium ' + corCabecalho +
                                                                        (values.modoApresentacao ? 'mt-10' : 'mt-12'/*'mt-13'*/)
                                                                }
                                                                dangerouslySetInnerHTML={{ __html: cabecalho }}
                                                            />
                                                        :
                                                            <div
                                                                className={
                                                                    'ml-5 text-24 font-medium ' + corCabecalho +
                                                                        (values.modoApresentacao ? 'mt-10' : 'mt-12'/*'mt-13'*/)
                                                                }
                                                            >
                                                                {cabecalho}
                                                            </div>
                                :
                                    ''
                            }
                        </GridItem11>
                    </GridContainerReport>
                </GridItem8>

                {(!vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioNaoExibirLogoCabecalho || values.modoApresentacao) && (
                    <GridItem4
                        align="right"
                    >
                        {AuthService.obterLogo(variaveisGlobais)
                            ?
                                <ImgLogoReport
                                    variaveisGlobais={variaveisGlobais}
                                    className="ml-0 mt-7"
                                    src={AuthService.obterLogo(variaveisGlobais)}
                                />
                            :
                                ''
                        }
                    </GridItem4>
                )}

                {(!vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioNaoExibirLinhaDivisoriaCabecalho || values.modoApresentacao) && (
                    <GridItem12
                        //className='bg-dark h-2px' 
                        className='bg-default h-4px' 
                    />
                )}
            </GridContainerReport>
        )
    }

    const Conteudo = () => {

        return (
            <div
                className={values.modoApresentacao ? 'ml-5 mt-10 mr-20' : 'ml-10 mt-2 mr-10'}
            >
                <GridContainerReport>
                    <GridItem12
                        align='left' // ajuste posicionamento modo apresentação
                        className={paginaInteira ? ''/*'mt--3 ml--4'*/ : ''}
                    >
                        {conteudo}
                    </GridItem12>
                </GridContainerReport>
            </div>
        )
    }

    const Rodape = () => {

        return (
            <GridContainerReport
                className={
                    vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioMargemTopoRodape
                        ?
                            'mt-' + vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].backgroundPaginaRelatorioMargemTopoRodape
                        :
                            ''
                }
            >
                <GridItem2
                    className={"mt-2"}
                >
                    {vars.fullWhiteLabel !== "S" && (
                        <SvgImageDesenvolvidoPorFintracks />
                    )}
                </GridItem2>

                <GridItem1/>

                <GridItem6
                    className="mt--3 text-rodapeRelatorio"
                    align="center"	
                >
                    {LABEL.elaboradoPor + " " +
                        //ClienteService.obterUsuarioClienteSelecionadoIdentificacao(variaveisGlobais)
                        AuthService.obterIdentificacaoUsuarioLogado(variaveisGlobais)
                    }
                    <br/>
                    {'(' + AuthService.obterEmailUsuarioLogado(variaveisGlobais) + ')'}
                    {/*
                        <br/>
                        {formataData(dataAtual())}
                    */}
                </GridItem6>

                <GridItem2
                    align="rigth"
                    className='mt--3 text-rodapeRelatorio'
                >
                    <h3>
                        {pagina}
                    </h3>
                </GridItem2>

                <GridItem1/>
                {/*
                <GridItem3
                    align="left"
                >
                    {AuthService.obterLogo(variaveisGlobais)
                        ?
                            <ImgLogoReport
                                variaveisGlobais={variaveisGlobais}
                                className="ml-4 mt-1"
                                src={AuthService.obterLogo(variaveisGlobais)}
                            />
                        :
                            ''
                    }
                </GridItem3>

                <GridItem6
                    align="center"	
                >
                    {LABEL.elaboradoPor + " " +
                        //ClienteService.obterUsuarioClienteSelecionadoIdentificacao(variaveisGlobais)
                        AuthService.obterIdentificacaoUsuarioLogado(variaveisGlobais)
                    }
                    <br/>
                    {formataData(dataAtual())}
                </GridItem6>

                <GridItem3
                    align="center"
                    className="mt-1"
                >
                    {vars.fullWhiteLabel !== "S" && (
                        <SvgImageDesenvolvidoPorFintracks />
                    )}
                </GridItem3>
                */}
            </GridContainerReport>
        )
    }



    return (
        values.modoApresentacao
            ?
                <div
                    className={(espacoModoApresentacao ? 'mb-20' : '') + (paginaInteira ? ' mt--15' : '')}
                >
                    {!paginaInteira && (
                        <Cabecalho/>
                    )}

                    <Conteudo/>
                </div>
            :
                <table
                    className={
                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                            ?
                                "paginaRetrato"
                            :
                                "paginaPaisagem"
                    }
                >
                    <tbody
                        className={classes.imgCapaBackground}
                    >
                        {!paginaInteira && (
                            <div
                                className={
                                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                                        ?
                                            "cabecalhoRetrato"
                                        :
                                            "cabecalhoPaisagem"
                                }
                            >
                                <div>
                                    <Cabecalho/>
                                </div>
                            </div>
                        )}

                        <div
                            className={
                                paginaInteira
                                    ?
                                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                                            ?
                                                "bodyPaginaInteiraRetrato"
                                            :
                                                "bodyPaginaInteiraPaisagem"
                                    :
                                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                                            ?
                                                "bodyRetrato"
                                            :
                                                "bodyPaisagem"
                            }
                        >
                            <div
                                style={{
                                    //padding: paginaInteira ? '0px' : '15px',
                                }}
                            >
                                <Conteudo/>
                            </div>
                        </div>

                        {!paginaInteira && (
                            <div
                                className={
                                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                                        ?
                                            "rodapeRetrato"
                                        :
                                            "rodapePaisagem"
                                }
                            >
                                <div>
                                    <Rodape/>
                                </div>
                            </div>
                        )}
                    </tbody>
                </table>
    )
}

export default EstudoReportPage